import { render, staticRenderFns } from "./gamesTop10.vue?vue&type=template&id=67241b7a&"
import script from "./gamesTop10.vue?vue&type=script&lang=js&"
export * from "./gamesTop10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports